<template>
  <SidebarWidget
    v-if="!company.email_verified"
    variant="warning"
  >
    <template v-slot:title>
      {{ $t('ui.widgets.verification.title') }}
    </template>

    <template v-slot:content>
      <p>{{ $t('ui.widgets.verification.message.a') }}</p>
      <p>{{ $t('ui.widgets.verification.message.b') }}</p>
      <hr />
    </template>

    <template v-slot:cta>
      <BaseButton
        v-if="!resent"
        class="w-full !px-base"
        :disabled="resending"
        :loading="resending"
        loadingDelay=".3s"
        @click.native="resend"
      >
        {{ $t('ui.widgets.verification.cta.initial') }}
      </BaseButton>
      <p v-else>
        {{ $t('ui.widgets.verification.cta.confirmed') }}
        <b class="block break-words">{{ company.email }}</b>
      </p>
    </template>
  </SidebarWidget>
</template>

<script setup>
// @ts-check

import { ref } from 'vue';
import { useActions, useGetters } from 'vuex-composition-helpers/dist';

import BaseButton from '@/components/library/buttons/BaseButton.vue';
import SidebarWidget from '@/components/library/widgets/SidebarWidget.vue';

const { company } = useGetters({
  company: 'company/company',
});
const { resendVerificationEmail } = useActions({
  resendVerificationEmail: 'company/RESEND_VERIFICATION_EMAIL',
});

const resending = ref(false);
const resent = ref(false);

async function resend() {
  try {
    resending.value = true;

    await resendVerificationEmail();

    resent.value = true;
  } finally {
    resending.value = false;
  }
}
</script>
